// 定义存储的 key 前缀
const STORAGE_KEYS = {
  AGENT_INFO: 'h5_agent_info_',
  AGENT_HISTORY: 'h5_agent_history_'
}

// 定义历史记录的类型
interface ChatMessage {
  id: string
  type: 'user' | 'assistant' | 'system'
  content: string
  timestamp: number
}

// 存储工具类
export const storage = {
  // 存储 AI 助手信息
  setAgentInfo(agentId: string, info: any) {
    localStorage.setItem(STORAGE_KEYS.AGENT_INFO + agentId, JSON.stringify(info))
  },

  // 获取 AI 助手信息
  getAgentInfo(agentId: string) {
    const data = localStorage.getItem(STORAGE_KEYS.AGENT_INFO + agentId)
    return data ? JSON.parse(data) : null
  },

  // 存储对话历史
  setAgentHistory(agentId: string, messages: ChatMessage[]) {
    localStorage.setItem(STORAGE_KEYS.AGENT_HISTORY + agentId, JSON.stringify(messages))
  },

  // 获取对话历史
  getAgentHistory(agentId: string): ChatMessage[] {
    const data = localStorage.getItem(STORAGE_KEYS.AGENT_HISTORY + agentId)
    return data ? JSON.parse(data) : []
  },

  // 添加新消息到历史记录
  addMessage(agentId: string, message: ChatMessage) {
    const history = this.getAgentHistory(agentId)
    history.push(message)
    this.setAgentHistory(agentId, history)
  },

  getSessionId: (agentId: string): string | null => {
    try {
      return localStorage.getItem(`chat_session_${agentId}`)
    } catch {
      return null
    }
  },

  setSessionId: (agentId: string, sessionId: string) => {
    try {
      localStorage.setItem(`chat_session_${agentId}`, sessionId)
    } catch {
      console.error('Failed to save sessionId')
    }
  },

  removeSessionId: (agentId: string) => {
    try {
      localStorage.removeItem(`chat_session_${agentId}`)
    } catch {
      console.error('Failed to remove sessionId')
    }
  }
} 